import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu-fullscreen-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "project-manager"
}
const _hoisted_3 = { class: "band-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_project_manager_project = _resolveComponent("project-manager-project")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_loading, null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Loading...", -1)
          ]))]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structure, (band) => {
          return (_openBlock(), _createElementBlock("div", {
            key: band.name,
            class: "project-manager-band"
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(band.name), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(band.projects, (project) => {
              return (_openBlock(), _createBlock(_component_project_manager_project, {
                key: project._id,
                project: project
              }, null, 8, ["project"]))
            }), 128))
          ]))
        }), 128))
      ]))
}